import React from "react";
import { FunctionEnum } from "../utils";
import { IFieldsMap } from "@common/redux/formBuilder/interface";

export function getActionLabel(
  functionType: FunctionEnum,
  fieldsMap: IFieldsMap,
  selectedArgs: string
): string {
  let value = "";
  const selectedArgText = selectedArgs?.replace(/\s/g, '');
  const arr = selectedArgText?.split(",");
  switch (functionType) {
    case FunctionEnum.Add:
    case FunctionEnum.DaysBetween:
      const field1 = arr[0];
      const field2 = arr[1];
      const fieldName1 =
        fieldsMap?.[field1]?.title ?? fieldsMap?.[field1]?.name ?? "";
      const fieldName2 =
        fieldsMap?.[field2]?.title ?? fieldsMap?.[field2]?.name ?? "";
      value = `${functionType}(${fieldName1},${fieldName2})`;
      break;
  }
  return value;
}
export function getAction(
  functionType: FunctionEnum,
  selectedArgs: string
): string {
  let value = "";
  const arr = selectedArgs.split(", ");
  switch (functionType) {
    case FunctionEnum.Add:
    case FunctionEnum.DaysBetween:
      const field1 = arr[0];
      const field2 = arr[1];
      value = `${functionType}(${field1},${field2})`;
      break;
  }
  return value;
}
